import { defineStore } from 'pinia';
import type { Student, EnrollmentStatusEnum } from '@/types/composition-functions';

export const useStudentOverviewStore = defineStore('studentOverview', () => {
  const searchQuery = ref('');
  const selectedClassroom = ref<string | null>(null);
  const selectedProgramme = ref<string | null>(null);
  const selectedCampus = ref<string | null>(null);
  const selectedStatus = ref<EnrollmentStatusEnum | null>(null);
  const page = ref(1);
  const rows = ref(20);
  const hasSearched = ref(false);

  // We can optionally cache the students data if we want instant load on back navigation
  // but we must ensure it doesn't get stale.
  // For now, let's persist filters and trigger a refetch if hasSearched is true.
  // Or we can cache the result.
  const cachedStudents = ref<Student[]>([]);
  const cachedTotalRecords = ref(0);

  function reset() {
    searchQuery.value = '';
    selectedClassroom.value = null;
    page.value = 1;
    rows.value = 20;
    hasSearched.value = false;
    cachedStudents.value = [];
    cachedTotalRecords.value = 0;
    selectedProgramme.value = null;
    selectedCampus.value = null;
    selectedStatus.value = null;
  }

  return {
    searchQuery,
    selectedClassroom,
    page,
    rows,
    hasSearched,
    cachedStudents,
    cachedTotalRecords,
    selectedProgramme,
    selectedCampus,
    selectedStatus,
    reset,
  };
});
